import { defineStore } from 'pinia';
import Network from "~/utils/network";

const urls = {
    statementWithId: (id) => `/administration/statement/${id}`,
};

export const useStatementPromptStore = defineStore('statementPrompt', {
    state: () => ({
        statementData: {},
    }),
    actions: {
        fetchOne: async function (id) {
            try {
                let data = await Network.http(urls.statementWithId(id));
                this.saveOne(data);
            } catch (err) {
                console.log(err);
                await Promise.reject(err);
            }
        },
        saveOne: function (data) {
            this.statementData[data.id] = data;
        },
    },
});
